import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import FeatureFlag from "./feature-flag.js";
import ir from "./feature-flags-provider-factory.js";
export function getFeatureFlag(t) {
  if (!e.rr()) return;
  const a = e.tr();
  if (a && !a.vi())
    return r.j.info("Feature flags are not enabled."), new FeatureFlag(t);
  const o = ir.er().Di();
  return o[t] ? o[t] : new FeatureFlag(t);
}
